import { render, staticRenderFns } from "./ChatGroupVideo.vue?vue&type=template&id=da464c4c&"
import script from "./ChatGroupVideo.vue?vue&type=script&lang=js&"
export * from "./ChatGroupVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports